import { Link } from 'react-router-dom';

type DossierStatut = {
  complet?: boolean;
  inscriptionEligible?: boolean;
  message?: string;
  messageInscription?: string;
};

type Props = {
  dossierStatut: DossierStatut | null;
  className?: string;
};

export default function ApprenantDossierBanner({ dossierStatut, className = '' }: Props) {
  const eligible = dossierStatut?.inscriptionEligible ?? dossierStatut?.complet;
  if (!dossierStatut || eligible) return null;

  return (
    <div
      className={`rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900 ${className}`}
    >
      <p className="font-bold">Pièce d&apos;identité requise</p>
      <p className="mt-1">
        {dossierStatut.messageInscription ??
          dossierStatut.message ??
          "Déposez et faites valider votre pièce d'identité avant de vous inscrire à une formation."}
      </p>
      <Link to="/app/documents" className="mt-2 inline-block text-xs font-bold text-primary">
        Compléter mon dossier →
      </Link>
    </div>
  );
}
